import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { fetchCompanyDetails, CompanyDetails } from "../api/contentful";

type CompanyDetailsContextValue = {
  data: CompanyDetails | null;
  loading: boolean;
  error: string | null;
};

const CompanyDetailsContext = createContext<CompanyDetailsContextValue | null>(
  null,
);

export function CompanyDetailsProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<CompanyDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchCompanyDetails()
      .then((res) => setData(res))
      .catch((err) =>
        setError(err.message || "Failed to load company details"),
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <CompanyDetailsContext.Provider value={{ data, loading, error }}>
      {children}
    </CompanyDetailsContext.Provider>
  );
}

export function useCompanyDetails(): CompanyDetailsContextValue {
  const context = useContext(CompanyDetailsContext);
  if (!context) {
    throw new Error("useCompanyDetails must be used within CompanyDetailsProvider");
  }
  return context;
}
